import { render, staticRenderFns } from "./TimeAllocationComponent.vue?vue&type=template&id=43320682&scoped=true"
import script from "./TimeAllocationComponent.vue?vue&type=script&lang=js"
export * from "./TimeAllocationComponent.vue?vue&type=script&lang=js"
import style0 from "./TimeAllocationComponent.vue?vue&type=style&index=0&id=43320682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43320682",
  null
  
)

export default component.exports